import React from 'react'
import { Link } from "react-router-dom";


const OurFacilites = () => {
  return (
    <>
      <section className="content-inner bg-light overflow-hidden">
        <div className="container">
          <div className="section-head style-1 row align-items-center mb-0">
            <div className="col-sm-12 m-b30 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <h2 className="title" style={{ textAlign: "center" }}>हमारे विभागों की गैलरी</h2>
            </div>
          </div>
        </div>
        <div className="swiper compare-swiper compare-swiper-wrapper m-b15 swiper-initialized swiper-horizontal swiper-backface-hidden">
          <div className="swiper-wrapper" id="swiper-wrapper-a16e5fe91e673712" aria-live="off" style={{ transitionDuration: '0ms', transform: 'translate3d(-1204px, 0px, 0px)', transitionDelay: '0ms' }}>
            <div className="swiper-slide wow fadeInUp" data-wow-delay="0.7s" data-wow-duration="0.8s" role="group" aria-label="7 / 8" data-swiper-slide-index={6} style={{ width: 324, marginRight: 20, visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.7s', animationName: 'fadeInUp' }}>
              <div className="dz-media radius-xl shadow-sm">
                <img src="./assets/img/unnamed.webp" alt />
              </div>
            </div>
            <div className="swiper-slide wow fadeInUp" data-wow-delay="0.8s" data-wow-duration="0.8s" role="group" aria-label="8 / 8" data-swiper-slide-index={7} style={{ width: 324, marginRight: 20, visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.8s', animationName: 'fadeInUp' }}>
              <div className="dz-media radius-xl shadow-sm">
                <img src="./assets/img/unnamed_1.webp" alt />
              </div>
            </div>
            <div className="swiper-slide wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="0.8s" role="group" aria-label="1 / 8" data-swiper-slide-index={0} style={{ width: 324, marginRight: 20, visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.1s', animationName: 'fadeInUp' }}>
              <div className="dz-media radius-xl shadow-sm">
                <img src="./assets/img/unnamed_2.webp" alt />
              </div>
            </div>
            <div className="swiper-slide wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" role="group" aria-label="2 / 8" data-swiper-slide-index={1} style={{ width: 324, marginRight: 20, visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-media radius-xl shadow-sm">
                <img src="./assets/img/unnamed_3.webp" alt />
              </div>
            </div>
            <div className="swiper-slide wow fadeInUp" data-wow-delay="0.8s" data-wow-duration="0.8s" role="group" aria-label="8 / 8" data-swiper-slide-index={7} style={{ width: 324, marginRight: 20, visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.8s', animationName: 'fadeInUp' }}>
              <div className="dz-media radius-xl shadow-sm">
                <img src="./assets/img/unnamed_1.webp" alt />
              </div>
            </div>
            <div className="swiper-slide wow fadeInUp" data-wow-delay="0.8s" data-wow-duration="0.8s" role="group" aria-label="8 / 8" data-swiper-slide-index={7} style={{ width: 324, marginRight: 20, visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.8s', animationName: 'fadeInUp' }}>
              <div className="dz-media radius-xl shadow-sm">
                <img src="./assets/img/unnamed_1.webp" alt />
              </div>
            </div>
            
          </div>
          <span className="swiper-notification" aria-live="assertive" aria-atomic="true" /></div>
        <div className="container wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
          <div className="slider__pagination compare-slider__pagination justify-content-center justify-content-md-start">
            <div className="slider__current compare-slider__current">04</div>
            <div className="swiper-progress compare-pagination-swiper swiper-pagination-progressbar swiper-pagination-horizontal"><span className="swiper-pagination-progressbar-fill" style={{ transform: 'translate3d(0px, 0px, 0px) scaleX(0.5) scaleY(1)', transitionDuration: '300ms' }} /></div>
            <div className="slider__total compare-slider__total">08</div>
          </div>
        </div>
      </section>

    </>
  )
}

export default OurFacilites